module.exports = __webpack_public_path__ + "static/media/ic-messages.af975dae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-messages.svg
// module id = 642
// module chunks = 14